import React, { Fragment} from 'react'
import { Table, TableBody, TableCell, TableContainer,
   TableHead, TableRow, Paper, TablePagination} from '@mui/material';
import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import ConsumableCatEdit from './ConsumableCatEdit';
import ConsumableCatRead from './ConsumableCatRead';
import { useEffect } from 'react';
import { useAddNewconsumcatMutation, useDeletebconsumcatMutation, useGetconsumcatQuery, useUpdateconsumcatMutation } from '../../../features/consumcat/consumcatApiSlice';
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import ExcelDownload from '../../../data/exceldownload';


const Addcategform = styled.form`
  display: flex;
  margin:10px;
`
const Displaydiv1 = styled.div`

`

const FormEleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items:center;
`
const Button2Div =styled.div`
  display: flex;
  justify-content: end;
`
const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
`

const ComplaintCategoryWrapper =styled.div`
  display: flex;
  align-items: center;
  justify-content:space-between;
`

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const tableFontSize = 18;


export default function ConsumableCat () {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);


  const {consumcat} = useGetconsumcatQuery("consumcat", {
    selectFromResult: ({data}) => ({
      consumcat: data?.entities
    }),
  })
  const [addNewConsumCat] = useAddNewconsumcatMutation();
  const [updateConsCat] = useUpdateconsumcatMutation();
  const [deleteConsCat] = useDeletebconsumcatMutation();

  const [tabledata, setTabledata]= useState([]);
  const [editCategory, setEditCategory]=useState(null);
  const [editFormData, setEditFormData]=useState({
    id:"",
    name:""
  });
  const [addConsumCatData, setAddConsumCatData] = useState({
    name:""
  });
  const [downloadData, setDownloadData] = useState({});
  const [sentData, setSentData ]= useState(0);

     // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onSubmit = async (event) =>{
    event.preventDefault();
    try{
      let bodyobject ={"name":addConsumCatData.name.trim()};
      const found = Object.values(consumcat).some(el => el.name === addConsumCatData.name);
      if(found) return alert(`Consumable Category "${addConsumCatData?.name}" already exists`)
      if(!found && addConsumCatData?.name?.length ){
          const res = await addNewConsumCat(bodyobject) ;
          alert(`New Consumable Category ${bodyobject.name} added in masters.`)
          setAddConsumCatData({});
          setSentData(sentData+1);
          }
    } catch(err){console.log(err)}
    setAddConsumCatData({})    
  }

  const onClickEdit = (e, k, row)=>{
    let tempEditFormData = {...editFormData};
    tempEditFormData.id = row?.id;
    tempEditFormData.name = consumcat[row.id]?.name;
    setEditFormData(tempEditFormData);
    setEditCategory(k+1);
  }

  const onChangeAddConsumCat = (event) =>{
    let temp ={...addConsumCatData}
    temp = {...temp, [event.target.name]:event.target.value}
    setAddConsumCatData(temp);
  }

  const onChangeEditConsumCat = (event) =>{
    let temp ={...editFormData}    
    temp = {...temp, [event.target.name]:event.target.value}    
    setEditFormData(temp);
  }

  const handleEditFormSubmit = async (e) =>{
    e.preventDefault();
    if(!editFormData.name.length){
      return alert("Please Enter valid values before submitting");
    }
    if(Object.values(consumcat).filter(a => a._id !== editFormData.id).map(x => x.name).includes(editFormData.name)){
      return alert("Consumable Category already exists in the database.")
    }
    try{
    setEditCategory(null);
    const response = await updateConsCat(editFormData)
    }catch(err){}
  }  

  const handleCancelClick = (e,k) => {   
    let tempEditFormData = {...editFormData};
    tempEditFormData.id = "";
    tempEditFormData.name = "";
    setEditFormData(tempEditFormData);
    setEditCategory(null);
  };

  const handleDeleteClick = async (e,k,row) => {
    e.preventDefault();
    let body = {"id":row.id}
    const response = window.confirm(`Do you want to delete Consumable Category "${row.name}"` )
    if(!response) return;
    alert(`Consumable Category"${row.name}" deleted successfully`);
    const result = await deleteConsCat(body);
  };  

  useEffect(()=>{
    if(consumcat){
      const consumcatArray = Object.values(consumcat);
      setTabledata(consumcatArray);     
    }
  },[consumcat])


//Setting the download data for excel download.
useEffect(()=>{
  let finalDownloadData = [];
  let finalSortedDownloadData = [];
  const keyOrderArray = ["name"]
  let tempDownloadData = structuredClone(tabledata);
  for(let val of tempDownloadData ){
      let {_id, ...others} = val;
      others = {...others, ["name"]: val.name }
      finalDownloadData.push(others)
    }
    for(let value of finalDownloadData){
        let tempObject = {}
        for(let val of keyOrderArray){
            tempObject = {...tempObject, [val]:value[val]};
        }
        finalSortedDownloadData.push(tempObject);
    }
    setDownloadData(finalSortedDownloadData)
}, [tabledata])
 
   
  return (
    <>
   
    <Displaydiv1>
      <HeadingWrap>
        <Span>Add New Consumable Category</Span>
      </HeadingWrap>

    <ComplaintCategoryWrapper>
      <Addcategform onSubmit={onSubmit}>
        <FormEleWrapper>
          <TextField
            id="outlined-basic"
            size='small'
            name='name'
            onChange={(event) => onChangeAddConsumCat(event)}
            label="Enter a New Consumable Category"
            value={addConsumCatData?.name || ""}
            variant="outlined"
            sx={{backgroundColor:"white", width:"300px", height:"40px"}}
          />
        <SubmitButton type='submit'>Submit</SubmitButton>
        </FormEleWrapper>        
      </Addcategform>
      <Button2Div>
          <ExcelDownload data={downloadData} filename={"consumablecat"} sheetName={"sheet1"}/>
        </Button2Div> 
    </ComplaintCategoryWrapper>

    <form onSubmit={handleEditFormSubmit}>

    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}  >
      <Table  aria-label="custom pagination table">
      <TableHead>
        <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"25%"}}}align="left">Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"30%"}}} align="left">Email Id</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"30%"}}} align="left">Edit</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, key) => ( 
            <Fragment key={key*2}>
              {editCategory=== key+1 ?
              
               <ConsumableCatEdit row={row} k={key} editFormData={editFormData} handleCancelClick={handleCancelClick} page={page}
                rowsPerPage={rowsPerPage} editCategory={editCategory} onChangeEditConsumCat={onChangeEditConsumCat} SubmitButton ={SubmitButton} 
               />

                :<ConsumableCatRead row={row} k={key} tabledata={tabledata} onClickEdit={onClickEdit}
                  handleDeleteClick= {handleDeleteClick} page={page} rowsPerPage={rowsPerPage} tableFontSize={tableFontSize} SubmitButton ={SubmitButton}              
                />
                 }
            </Fragment>                   
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </form>    
    </Displaydiv1>
    </>
  );
}